export default __webpack_public_path__ + "static/media/ellipsis-v-solid.72a3efd9.svg";